export const cdi = {
  'cdi-absence-reports': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/absence_reports.svg?inline'
      ),
  },
  'cdi-accounts': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/accounts.svg?inline'
      ),
  },
  'cdi-additional-components': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/additional_components.svg?inline'
      ),
  },
  'cdi-anchor-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/anchor_new.svg?inline'
      ),
  },
  'cdi-api-token': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/api_token.svg?inline'
      ),
  },
  'cdi-bag-check': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/bag_check.svg?inline'
      ),
  },
  'cdi-calendar': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/calendar.svg?inline'
      ),
  },
  'cdi-ceas': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/ceas.svg?inline'
      ),
  },
  'cdi-certificate-types': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/certificate_types.svg?inline'
      ),
  },
  'cdi-certificates': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/certificates.svg?inline'
      ),
  },
  'cdi-code': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/code.svg?inline'
      ),
  },
  'cdi-connector-exports': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/connector_exports.svg?inline'
      ),
  },
  'cdi-connector-profiles': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/connector_profiles.svg?inline'
      ),
  },  
  'cdi-contracts': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/contracts.svg?inline'
      ),
  },
  'cdi-copy-up': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/copy_up.svg?inline'
      ),
  },
  'cdi-cost-centers': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/cost_centers.svg?inline'
      ),
  },
  'cdi-corrections': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/corrections.svg?inline'
      ),
  },
  'cdi-created-phases': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/project_tasks.svg?inline'
      ),
  },
  'cdi-declaration-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/declarations_new.svg?inline'
      ),
  },
  'cdi-declarations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/declarations.svg?inline'
      ),
  },
  'cdi-devices': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/devices.svg?inline'
      ),
  },
  'cdi-disable-work-schedules': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/disable_work_schedules.svg?inline'
      ),
  },
  'cdi-document-categories': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/document_categories.svg?inline'
      ),
  },
  'cdi-executed-check': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/executed_check.svg?inline'
      ),
  },
  'cdi-emergency': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/emergency.svg?inline'
      ),
  },
  'cdi-external-employees': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/external_employees.svg?inline'
      ),
  },
  'cdi-general-ledger-accounts': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/ledger_accounts.svg?inline'
      ),
  },
  'cdi-groups': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/groups.svg?inline'
      ),
  },
  'cdi-home': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/Home.svg?inline'
      ),
  },
  'cdi-hour-components': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/hour_components.svg?inline'
      ),
  },
  'cdi-hour-reports': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/hour_reports.svg?inline'
      ),
  },
  'cdi-hour-types': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/hour_types.svg?inline'
      ),
  },  
  'cdi-installation-parts': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/installation_parts.svg?inline'
      ),
  },
  'cdi-invoice-concept': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/invoice_concept.svg?inline'
      ),
  },
  'cdi-invoice-pending': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/invoice_pending.svg?inline'
      ),
  },
  'cdi-internal-employees': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/user.svg?inline'
      ),
  },
  'cdi-invoice': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/invoice.svg?inline'
      ),
  },
  'cdi-item-categories': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/item_categories.svg?inline'
      ),
  },
  'cdi-items': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/items.svg?inline'
      ),
  },
  'cdi-jetty': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/jetty.svg?inline'
      ),
  },
  'cdi-jobs': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/jobs.svg?inline'
      ),
  },
  'cdi-leave-request-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/leave_request_new.svg?inline'
      ),
  },
  'cdi-leave-request-type-balances': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/leave_request_type_balances.svg?inline'
      ),
  },
  'cdi-leave-request-types': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/leave_request_types.svg?inline'
      ),
  },
  'cdi-leave-requests': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/absence_reports.svg?inline'
      ),
  },
  'cdi-lock-actions': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/slot.svg?inline'
      ),
  },
  'cdi-locks': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/slot.svg?inline'
      ),
  },
  'cdi-machines': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/machines.svg?inline'
      ),
  },
  'cdi-manage-functions': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/manager_roles.svg?inline'
      ),
  },
  'cdi-measure-types': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/measure_types.svg?inline'
      ),
  },
  'cdi-missing-invoices': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/missing_invoices.svg?inline'
      ),
  },
  'cdi-menu': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/Menu.svg?inline'
      ),
  },
  'cdi-missing-time-registrations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/missing_time_registrations.svg?inline'
      ),
  },
  'cdi-missing-work-orders': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/missing_work_orders.svg?inline'
      ),
  },
  'cdi-mutations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/project_mutations.svg?inline'
      ),
  },
  'cdi-my-time-registrations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/my_time_registrations.svg?inline'
      ),
  },
  'cdi-new-leave-request': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/new_leave_request.svg?inline'
      ),
  },
  'cdi-new-reparation': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/new_time_registration.svg?inline'
      ),
  },
  'cdi-new-time-registration': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/new_time_registration.svg?inline'
      ),
  },  
  'cdi-no-icon': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/no_icon.svg?inline'
      ),
  },
  'cdi-not-authorized-work-orders': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/pending_work_orders.svg?inline'
      ),
  },
  'cdi-notice-of-readiness': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/notice_of_readiness.svg?inline'
      ),
  },
  'cdi-operating-companies': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/operating_companies.svg?inline'
      ),
  },
  'cdi-permits': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/permits.svg?inline'
      ),
  },
  'cdi-pending_work': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/pending_work.svg?inline'
      ),
  },
  'cdi-phase-groups': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/phase_groups.svg?inline'
      ),
  },
  'cdi-planner-planning': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/planner_planning.svg?inline'
      ),
  },
  'cdi-price-lists': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/price_lists.svg?inline'
      ),
  },
  'cdi-projects': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/projects.svg?inline'
      ),
  },
  'cdi-project-quote': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/project_quote.svg?inline'
      ),
  },
  'cdi-new-project': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/new_project.svg?inline'
      ),
  },
  'cdi-posts': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/posts.svg?inline'
      ),
  },
  'cdi-quotation': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/quotation.svg?inline'
      ),
  },
  'cdi-quotation-draft': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/quotation_draft.svg?inline'
      ),
  },
  'cdi-quotation-pending': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/quotation_pending.svg?inline'
      ),
  },
  'cdi-reparations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/reparations.svg?inline'
      ),
  },
  'cdi-reparation-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/reparation_new.svg?inline'
      ),
  },
  'cdi-risks': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/risks.svg?inline'
      ),
  },
  'cdi-roles': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/roles.svg?inline'
      ),
  },
  'cdi-settings': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/settings.svg?inline'
      ),
  },
  'cdi-shiploads': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/shiploads.svg?inline'
      ),
  },
  'cdi-ship-clock-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/ship_clock_new.svg?inline'
      ),
  },
  'cdi-ship-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/ship_new.svg?inline'
      ),
  },
'cdi-ship-pen': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/ship_pen.svg?inline'
      ),
  },
  'cdi-sick-registration-types': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/sick_registration_types.svg?inline'
      ),
  },
  'cdi-sick-registrations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/sick_registrations.svg?inline'
      ),
  },
  'cdi-status-check-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/status_check_new.svg?inline'
      ),
  },
  'cdi-status-check': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/status_check.svg?inline'
      ),
  },
  'cdi-subscriptions': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/subscriptions.svg?inline'
      ),
  },
  'cdi-tank': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/tank.svg?inline'
      ),
  },
  'cdi-telephone': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/telephone.svg?inline'
      ),
  },
  'cdi-time-registration-new': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/time_registration_new.svg?inline'
      ),
  },
  'cdi-time-registrations': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/time_registrations.svg?inline'
      ),
  },
  'cdi-timesheets': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/timesheets.svg?inline'
      ),
  },
  'cdi-toolbox-assignments-closed': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/toolbox_assignments_closed.svg?inline'
      ),
  },
  'cdi-toolbox-assignments-finished': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/toolbox_assignments_finished.svg?inline'
      ),
  },
  'cdi-toolbox-assignments-open': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/toolbox_assignments_open.svg?inline'
      ),
  },
  'cdi-toolbox-assignments': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/toolbox_assignments.svg?inline'
      ),
  },
  'cdi-toolbox-topics': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/toolbox_topics.svg?inline'
      ),
  },
  'cdi-units': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/units.svg?inline'
      ),
  },
  'cdi-user-functions': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/user_functions.svg?inline'
      ),
  },
  'cdi-user-planning': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/user_planning.svg?inline'
      ),
  },
  'cdi-user': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/user.svg?inline'
      ),
  },
  'cdi-vat-rates': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/vat_rates.svg?inline'
      ),
  },
  'cdi-visits': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/visits.svg?inline'
      ),
  },
  'cdi-waste-stream-numbers': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/waste_stream_numbers.svg?inline'
      ),
  },
  'cdi-work-activities': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/work_activities.svg?inline'
      ),
  },
  'cdi-work-instructions': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/work_instructions.svg?inline'
      ),
  },
  'cdi-work-orders': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/work_orders.svg?inline'
      ),
  },
  'cdi-new-work-orders': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/new_work_orders.svg?inline'
      ),
  },
  'cdi-logs': {
    component: () =>
      import(
        /* webpackMode: "eager" */ '@/assets/images/icons/logs.svg?inline'
      ),
  },
};